export default __webpack_public_path__ + "static/media/icon_twitter.e69242fe.svg";